<template>
    <div class='body-main'>
        <div class='cart-header'>
            <div class='cart-header-warp clearfix'>
                <div class='cart-title left clearfix'>
                    <h1 class='left'>确认订单</h1>
                </div>
                <div class='right'>


                </div>
            </div>
        </div>
        <div class='cart-body'>
            <div class="title-box clearfix">
                <p class='l goods-info-title'>商品信息</p>
                <a href="javascript:void(0);" target="_blank" class="r">我有疑问，需要反馈？</a>
            </div>
            <div class="detail-box">
                <el-table
                        :data="tableData"
                        style="width: 100%">
                    <el-table-column
                            label="信息" type="expand">
                        <template slot-scope="props">
                            <el-form label-position="left" inline class="demo-table-expand">
                                <el-form-item>
                                    <el-tag style="margin:5px;" v-for="item in props.row.apply" :key="item">{{ item }}
                                    </el-tag>
                                </el-form-item>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="工种类别"
                            prop="gzleibie"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="工种项目"
                            prop="gzxiangmu"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="工种类型"
                            prop="gzleixing"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="数量"
                            prop="buyNumber"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="总价格"
                            width="180">
                        <template slot-scope="scope">
                            <span>{{(scope.row.buyNumber * scope.row.gzprice) | format}}</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pay-box clearfix">
                <div class="goods-total-price-box clearfix">
                    <p class="r rw price-num">
                        <em>￥</em><span id="js-actual-price">{{totalMoney | formats}}</span>
                    </p>
                    <p class="r price-text">共 <span>{{totalNumber}}</span> 件商品，商品总金额：</p>
                </div>

                <div class="pay-price-box clearfix">
                    <p class="r rw price">
                        <em>￥</em><span id="js-pay-price">{{totalMoney | formats}}</span>
                    </p>
                    <p class="r price-text">应付：</p>
                </div>
                <div class="pay-account-box clearfix">
                    <p class="pay-account r">购买账号：<span>{{this.$store.state.userNeme}}</span>
                    </p>
                </div>
                <el-tooltip content="返回修改订单" placement="top" effect="light">
                    <el-button @click="gocart" icon="el-icon-back" circle></el-button>
                </el-tooltip>
                <a href="javascript:void(0);" @click="submitOrder" class="r moco-btn-red submit-btn js-pay-submit"
                   data-typecate="normal">提交订单</a>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "pay",
        components:
            {
                axios,
            }
        ,
        data() {
            return {
                tableData: [],
                totalMoney: 0,
                totalNumber: 0,
                allid: [],
            }
        },
        methods: {
            //返回购物车
            gocart() {
                this.$router.push({
                    name: 'Cart',
                })
            },
            //确认订单
            submitOrder() {
                //创建订单 删除购物车数据
                axios.post("/Api/admin/addOrderData", {id: this.allid}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.$router.push({
                                name: 'Payfortheorder',
                                params: {
                                    id: res.data.data
                                }
                            })
                        } else if (res.data.errcode == 40000) {
                            this.$router.push({
                                name: 'Cart',
                            })
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error',
                                duration: 10000
                            });
                        }

                    } else {
                        //操作失败
                        this.$message({
                            showClose: true,
                            message: '提交订单失败！请刷新重试！',
                            type: 'error',
                            duration: 10000
                        });
                    }
                });
            }
        },
        mounted() {
            if (this.$route.params.id == null) {
                this.$router.push({
                    name: 'Cart',
                })
            } else {
                axios.post("/Api/admin/getPayData", {id: this.$route.params.id}).then(res => {
                    if (res.statusText == "OK") {
                        if (res.data.errcode == 0) {
                            this.tableData = res.data.data;
                            //计算商品总是和总金额
                            for (var num in this.tableData) {
                                this.totalMoney = this.totalMoney + (this.tableData[num].buyNumber * this.tableData[num].gzprice);
                                this.totalNumber = this.totalNumber + this.tableData[num].buyNumber;
                                this.allid.push(this.tableData[num]._id);
                            }
                        } else if (res.data.errcode == 40000) {
                            this.$router.push({
                                name: 'Cart',
                            })
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error',
                                duration: 10000
                            });
                        }

                    } else {
                        //操作失败
                        this.$message({
                            showClose: true,
                            message: '获取数据失败，请重新登入！',
                            type: 'error',
                            duration: 10000
                        });
                    }
                });
            }
        },
        filters: {  //数据过滤器
            format: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return "￥ " + value + ".00";
                }
                _val = value.split('.');
                return '￥ ' + _val[0] + '.' + _val[1];
            },
            formats: function (value) {
                var _val;
                value = Number(value).toFixed(2);
                if (value == 0) {
                    value = 0;
                    return value + ".00";
                }
                _val = value.split('.');
                return _val[0] + '.' + _val[1];
            }
        }
    }
</script>

<style>
    .title-box {
        padding-top: 36px;
        padding-bottom: 24px;
    }

    .title-box .goods-info-title {
        margin-left: 12px;
        color: #07111b;
        font-size: 16px;
        line-height: 16px;
    }

    .title-box a {
        color: #93999f;
        font-size: 12px;
        line-height: 16px;
    }

    .r {
        float: right;
    }

    .detail-box {
        width: 100%;
    }

    .pay-box {
        margin-top: 36px;
    }

    .goods-total-price-box {
        margin-bottom: 16px;
    }

    .pay-box .goods-total-price-box .price-num {
        position: relative;
        font-size: 14px;
        line-height: 14px;
        color: #07111b;
    }

    .pay-box .rw {
        width: 140px;
        box-sizing: border-box;
        text-align: right;
    }

    .pay-box .coupons-discount-box .price-text, .pay-box .goods-total-price-box .price-text, .pay-box .package-discount-box .price-text, .pay-box .student-discount-box .price-text {
        text-align: right;
        font-size: 14px;
        color: #07111b;
        line-height: 14px;
    }

    .pay-box .pay-price-box {
        color: #07111b;
    }

    .pay-box .pay-price-box .price {
        position: relative;
        color: #f01414;
        font-size: 24px;
        line-height: 24px;
        font-weight: 700;
    }

    .pay-box .pay-account {
        font-size: 12px;
        color: #93999f;
        line-height: 24px;
        margin-bottom: 20px;
        margin-top: 15px;
    }

    .pay-box .submit-btn {
        padding: 0;
        width: 140px;
        height: 40px;
        text-align: center;
        font-size: 14px;
        line-height: 40px;
        border-radius: 18px;
    }

    .moco-btn-red:link, .moco-btn-red:visited {
        color: #fff;
    }

    .moco-btn-red {
        cursor: pointer;
        color: #fff;
        background-color: #f20d0d;
        border-color: #f20d0d;
        opacity: 1;
    }

    .moco-btn-red:hover, .moco-btn-red:focus, .moco-btn-red.focus, .moco-btn-red:active, .moco-btn-red.active {
        color: #fff;
        border-color: #c20a0a;
        background: #c20a0a;
        opacity: 1;
    }

</style>